module.exports = __webpack_public_path__ + "img/avatar-06.BMGK9R1I.8b5b33b5.jpg";